import { render, staticRenderFns } from "./EditDetails.vue?vue&type=template&id=2597809e&"
import script from "./EditDetails.vue?vue&type=script&lang=js&"
export * from "./EditDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports